import { render, staticRenderFns } from "./DeliveryOption.vue?vue&type=template&id=71a03581&scoped=true&"
import script from "./DeliveryOption.vue?vue&type=script&lang=js&"
export * from "./DeliveryOption.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOption.vue?vue&type=style&index=0&id=71a03581&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a03581",
  null
  
)

export default component.exports